import {FusionCharts} from '@crema/modules/thirdParty';

export default FusionCharts;
